import { react2angular } from 'react2angular';
import {
  getSegmentValuesSummary,
  isSmartTvChannel,
  SEGMENT_ROW_MAP,
  SEGMENT_ROW_TYPES,
  isCategoriesEnabled,
  isPurchaseAffinitiesEnabled,
} from 'data/audience-segment-builder-helper';
import { getAudienceSize, getSegmentInsightsData, getSegmentInsightsParams, isAudienceSizeTooSmall, getFirstPartyDataByProgram}
  from 'react/services/AudienceInsightsService';
import { QUERY_NAMES, SG_CHANNELS } from 'react/services/AudienceServiceHelper';
import { PERMISSION } from 'infra/utils/export';
import { CHANNEL_IDS, AUDIENCE_STATES, USER_TYPES } from 'data/audience-channels';
import {
  EXPLORER_TAB_NAMES,
  EXPLORER_TAB_VALUES,
  EXPLORER_TAB_LABELS,
} from 'react/components/apps/audience/AudienceExplorer/AudienceInsightsWidget/constants';
import AudienceExplorerTopBar
    from 'react/components/apps/audience/AudienceExplorer/AudienceExplorerTopBar/AudienceExplorerTopBar';
import AudienceExplorerSecondaryBar
    from 'react/components/apps/audience/AudienceExplorer/AudienceExplorerSecondaryBar/AudienceExplorerSecondaryBar';
import { checkNameSensitivity, checkSensitivity } from 'react/utils/sensitivityUtils';
import * as MixpanelAudience from 'react/infra/mixpanel/MixpanelAudience';
import { updateShowShortSpinner } from 'react/redux/slices/spinnerSlice';
import AudienceInsightsWidget
    from 'react/components/apps/audience/AudienceExplorer/AudienceInsightsWidget/AudienceInsightsWidget';
import audienceDemographicsWidget from 'widgets/audience-demographics-widget/audience-demographics-widget';
import audienceTvWidget from 'widgets/audience-tv-widget/audience-tv-widget';
import audienceTableViewWidget from 'widgets/audience-table-view-widget/audience-table-view-widget';
import audienceLinkedinInterestsWidget from '../../widgets/audience-linkedin-interests-widget/audience-linkedin-interests-widget';
import amTabs from 'common/am-tabs.drv/am-tabs.drv';
import audienceExplorerExportServiceModule from 'data/audience-explorer-export-service';
import segmentInterestExportServiceModule from 'data/segment-interest-export-service';
import defineInterestModule from 'common/modals/define-interest/define-interest';
import audienceTableStruct from 'widgets/audience-table-view-widget/audience-table-struct';

// Local constants
const TVA_LITE_TOOLTIP = 'Contact your Amobee Account Manager to learn more about advanced insights-to-activation.';

const audienceExplorerModule = angular.module(__filename, [
    audienceDemographicsWidget.name,
    audienceTvWidget.name,
    audienceTableViewWidget.name,
    audienceLinkedinInterestsWidget.name,
    amTabs.name,
    audienceExplorerExportServiceModule.name,
    segmentInterestExportServiceModule.name,
    defineInterestModule.name,
    audienceTableStruct.name
]);

audienceExplorerModule.component('audienceExplorerTopBar', react2angular(AudienceExplorerTopBar, ['audienceName', 'audienceInfoTooltipContent']))
                      .component('audienceExplorerSecondaryBar', react2angular(AudienceExplorerSecondaryBar, ['onExportClick', 'tabs', 'selectedTab', 'onTabSelect', 'onRefineAudienceClick']))
                      .component('audienceInsightsWidget', react2angular(AudienceInsightsWidget, ['handleActivatingAudience', 'handleActivatingTarget', 'navToPrevTab', 'navToAudienceBuilder', 'exportControl', 'selectedTab', 'tabsNames', 'audienceChannel', 'segment', 'context', 'abiPermissions', 'audienceTableStructure', 'infraUtil', 'termsMold', 'keywordSuggester', 'defineInterestModal', 'segmentInterestExportService', 'notificator', 'dspService', 'ssoService', 'user', 'targetsCommon', 'targets'], ['$state', '$scope']));

audienceExplorerModule.stateConfig = [{
    name: AUDIENCE_STATES.EXPLORER,
    url: `/${AUDIENCE_STATES.EXPLORER}`,
    template: require("./audience-explorer.html"),
    display: "Audience",
    controller: audienceExplorerController,
    data: {
      permissions: [PERMISSION.AUDIENCE]
    }
}];


audienceExplorerController.$inject = ["$scope", "$state", "abiPermissions", "context", "filtersPartition",
    'audienceMgmt', 'notificator', 'TargetsCommon', '$q', 'audienceExplorerExportService', 'segmentInterestExportService',
    '$ngRedux', '$rootScope', 'util', 'dspService', 'TermsMold', 'keywordSuggester', 'defineInterestModal', 'audienceTableStructure'];
function audienceExplorerController($scope, $state, abiPermissions, context, filtersPartition, audienceMgmt,
                                    notificator, TargetsCommon, $q, audienceExplorerExportService,
                                    segmentInterestExportService, $ngRedux, $rootScope, util, dspService, TermsMold, keywordSuggester, defineInterestModal, audienceTableStructure) {

    const channel = context.current.audience_app.current_channel.value;
    let showTvTab;
    $scope.infraUtil = util;
    $scope.termsMold = new TermsMold();
    $scope.keywordSuggester = keywordSuggester;
    $scope.defineInterestModal = defineInterestModal;
    $scope.audienceTableStructure = audienceTableStructure;
    $scope.dspService = dspService;
    $scope.abiPermissions = abiPermissions;
    $scope.context = context;
    $scope.segmentInterestExportService = segmentInterestExportService;
    $scope.notificator = notificator;
    $scope.user = $rootScope.user;
    $scope.targetsCommon = TargetsCommon;
    $scope.targets = [];
    $scope.$state = $state;
    $scope.hasPermission = abiPermissions.hasPermission;
    $scope.channel = channel;
    $scope.audienceName = (context.current.audience_app[channel] || {}).audience_name;
    $scope.exportControl = {};
    $scope.TABS_NAMES = EXPLORER_TAB_NAMES;

    // each channel support other types of data
    if(channel === CHANNEL_IDS.LINKEDIN)
        $scope.tabs = [{label: EXPLORER_TAB_LABELS.LINKEDIN_INTERESTS, value: EXPLORER_TAB_VALUES.LINKEDIN_INTERESTS}];
    else {
        const debugUser = $scope.$root.user.userType === USER_TYPES.DEBUG;
        const isTvChannelPartialData = channel === CHANNEL_IDS.TIVO && !abiPermissions.hasPermission(PERMISSION.AUDIENCE_TV_CHANNEL_COMPLETE_DATA);

        showTvTab = !SG_CHANNELS.includes(channel) && channel !== CHANNEL_IDS.AU_TELCO && channel !== CHANNEL_IDS.ARTICLES &&
                          abiPermissions.hasPermission([PERMISSION.TV]) && !isTvChannelPartialData;
        const showInterestsTab = abiPermissions.hasPermission([PERMISSION.INTERESTS]) &&
        !isTvChannelPartialData;
        const hasTvaLitePermission = isSmartTvChannel(channel) && abiPermissions.hasPermission(PERMISSION.SMART_TVA_LITE);
        const audienceSegment = (context.current.audience_app[channel] || {}).audience_segment || [];

        $scope.tabs = _.compact([
            abiPermissions.hasPermission([PERMISSION.DEMOGRAPHICS]) && {label: EXPLORER_TAB_LABELS.DEMOGRAPHICS, value: EXPLORER_TAB_VALUES.DEMOGRAPHICS},
            debugUser && {label: EXPLORER_TAB_LABELS.WEBSITES, value: EXPLORER_TAB_VALUES.DOMAIN},
            debugUser && {label: EXPLORER_TAB_LABELS.KEYWORDS, value: EXPLORER_TAB_VALUES.KEYWORDS},
            debugUser && {label: EXPLORER_TAB_LABELS.CONSUMED_PHRASES, value: EXPLORER_TAB_VALUES.WEB},
            showInterestsTab && {label: EXPLORER_TAB_LABELS.INTERESTS, value: EXPLORER_TAB_VALUES.WIKI, ...(hasTvaLitePermission && {isDisabled: true, tooltip: TVA_LITE_TOOLTIP})},
            showTvTab && {label: EXPLORER_TAB_LABELS.TV_SHOWS, value: EXPLORER_TAB_VALUES.TV, ...(hasTvaLitePermission && {isDisabled: true, tooltip: TVA_LITE_TOOLTIP})},
            isPurchaseAffinitiesEnabled(audienceSegment, channel, abiPermissions) && {label: EXPLORER_TAB_LABELS.PURCHASE_AFFINITIES, value: EXPLORER_TAB_VALUES.PURCHASE_AFFINITIES},
            isCategoriesEnabled(audienceSegment, channel, abiPermissions) && {label: EXPLORER_TAB_LABELS.CATEGORIES, value: EXPLORER_TAB_VALUES.CATEGORIES},
        ]);
    }

    $scope.SEGMENT_MAP = SEGMENT_ROW_MAP;
    $scope.selectedTab = $scope.tabs[0];

    // Fetch and merge first-party data on load
    // This function fetches first-party segment data including labels and sizes,
    // then merges this data into the existing audience segments so that
    // audienceInfoTooltipContent can display the correct labels and sizes.
    async function loadAndMergeFirstPartyData() {
        try {
            if (context.program && abiPermissions.hasPermission(PERMISSION.FIRST_PARTY_SEGMENT)) {
                const channel = context.current.audience_app.current_channel.value;
                const audienceApp = context.current.audience_app[channel];
                
                // Check if there are first-party segments in the audience
                if (audienceApp && audienceApp.audience_segment && 
                    audienceApp.audience_segment.some(segment => segment.type === SEGMENT_ROW_TYPES.FIRST_PARTY.value)) {
                    
                    const firstPartyData = await getFirstPartyDataByProgram(context.program, { shouldFetchSegmentSizes: true });
                    
                    // Create a map of first-party segments by segment_value for quick lookup
                    const firstPartyMap = {};
                    firstPartyData.forEach(segment => {
                        firstPartyMap[segment.segment_value] = segment;
                    });

                    // Filter and merge first-party data into audience segments
                    audienceApp.audience_segment = audienceApp.audience_segment.filter(segment => {
                        if (segment.type !== SEGMENT_ROW_TYPES.FIRST_PARTY.value) return true; // Keep non-first-party segments

                        // Try to match by different possible fields
                        let firstPartySegment = firstPartyMap[segment.value];
                        if (!firstPartySegment && segment.segment_value) {
                            firstPartySegment = firstPartyMap[segment.segment_value];
                        }
                        
                        // Remove segment if:
                        // 1. It's not found in the API response (deleted from DB)
                        // 2. It has pending_expiration: true
                        if (!firstPartySegment || firstPartySegment.pending_expiration === true) {
                            return false;
                        }
                        
                        return true;
                    }).map(segment => {
                        if (segment.type === SEGMENT_ROW_TYPES.FIRST_PARTY.value) {
                            // Try to match by different possible fields
                            let firstPartySegment = firstPartyMap[segment.value];
                            if (!firstPartySegment && segment.segment_value) {
                                firstPartySegment = firstPartyMap[segment.segment_value];
                            }
                            
                            if (firstPartySegment) {
                                return {
                                    ...segment,
                                    label: firstPartySegment.label || segment.label,
                                    segment_size: firstPartySegment.segment_size,
                                    pending_expiration: firstPartySegment.pending_expiration
                                };
                            }
                        }
                        return segment;
                    });
                    
                    // Trigger digest cycle to update the UI
                    $scope.$apply();
                }
            }
        } catch (error) {
            console.error('Failed to load first-party data:', error);
            // Don't throw the error to avoid breaking the page load
        }
    }

    // Load first-party data on initialization
    loadAndMergeFirstPartyData();

    $scope.handleActivatingTarget = ()=> {
        const audience = context.current.audience_app[$scope.channel];
        const segment = audience.audience_segment;
        const channel = $scope.channel;
        TargetsCommon.openAudienceContextualTarget({
            segment,
            channel,
            phrasesPromise: ()=> getSegmentInsightsData(audience.audience_segment, QUERY_NAMES.phrases, $scope.channel),
            query: getSegmentInsightsParams(segment, QUERY_NAMES[$scope.tab], channel),
            audience_name: context.current.audience_app[$scope.channel].audience_name,
            $scope,
            program_id: context.current.p_id
        });
    };

    function handleAudienceSensitivity(audience, props) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    reviewSensitivityHandler,
                    sensitivityData,
                } = await checkSensitivity(audience, (newSegments) => {
                    if (newSegments) audience.segments = newSegments;

                    $scope.reviewSensitivity = { isOpen: false };
                    $scope.$apply();
                    resolve({ isDirty: !_.isEmpty(newSegments) });
                });

                if (_.isEmpty(sensitivityData)) return resolve({ isDirty: false });

                const cancelHandler = () => {
                    $scope.reviewSensitivity = { isOpen: false };
                    $scope.$apply();
                    resolve({ canceled: true });
                };
                $scope.reviewSensitivity = {
                    isOpen: true,
                    data: sensitivityData,
                    onCancel: cancelHandler,
                    onSubmit: reviewSensitivityHandler,
                    ...props,
                };
                $scope.$apply();
            } catch (e) {
                reject(e);
            }
        });
    }

    let saveInProcess = false;
    async function saveAudience(props) {
        if (saveInProcess) return { canceled: true };

        saveInProcess = true;
        try {
            const { channel } = $scope;
            const audienceApp = context.current.audience_app[channel];
            const {
                audience_id,
                audience_name,
                audience_segment: segments,
                audience_advancedSegmentation: advancedSegmentation,
                is_audience_dirty,
            } = audienceApp;
            const audience = {
                id: audience_id,
                name: audience_name,
                segments: _.cloneDeep(segments),
                advancedSegmentation,
                channel,
            };
            const {canceled, isDirty} = isSmartTvChannel(channel)
              ? await handleAudienceSensitivity(audience, props)
              : { canceled: false, isDirty: false};
            if (canceled) return { canceled: true };

            // skip saving of audience if there are no segments to save (because removing the sensitive ones cleared everything)
            audienceApp.audience_segment = audience.segments;
            if (_.isEmpty(audience.segments)) return { canceled: true };

            // skip saving of audience if it is not changed
            if (!isDirty && !is_audience_dirty) return { canceled: false };

            const data = {
                name: audience_name,
                segments: _.cloneDeep(segments),
                advancedSegmentation,
                channel,
            };

            const res = await (audience_id ? audienceMgmt.update(audience_id, {data}) : audienceMgmt.create({data}));
            audienceApp.audience_id = res.id;
            const msg = `The audience "${audience_name}" was saved successfully`;
            notificator.success({body: msg});
            await audienceApp.finalizeSave(res);
            return { canceled: false };
        } catch (e) {
            const msg = 'Failed saving audience';
            notificator.error({ body: msg });
            return { canceled: true };
        } finally {
            saveInProcess = false;
        }
    }

    async function checkDemographicsData(segment, channel, userId, {isBidstream = false, minimalSize = 150, filterBidstreamDomains = true}) {
        const options = {
            channel,
            userId,
            isBidstream,
            minimalSize,
            filterBidstreamDomains,
        };
        const size = await getAudienceSize(segment, options);
        if (isAudienceSizeTooSmall(size)) {
            notificator.error('Your audience is too narrow and cannot be activated. Please refine your audience.');
            return false;
        }
        return true;
    }

    async function checkName(id, name) {
        if (!name) return { isValid: false };

        const { channel } = $scope;
        const { current: { audience_app: { [channel]: audienceApp} } } = context;
        const audiences = await audienceApp.getProgramAudiencePromise;
        const nameExists = !_.isEmpty(audiences) && !!audiences.find((a) => a.id !== id && a.name.toLowerCase() === name.toLowerCase());
        if (nameExists) return {
            error: `The name "${name}" already exists. Please choose a different name.`,
            isValid: false,
        };

        const {passed, text} = await checkNameSensitivity(name);
        if (!passed) return { error: text, isValid: false };

        return { isValid: true };
    }

    function getAudienceName(id, origName) {
        return new Promise(async (resolve) => {
            const { isValid, error } = await checkName(id, origName);
            if (isValid) {
                return resolve({ name: origName });
            }

            $scope.audienceNameProps = {
                isOpen: true,
                origName,
                origErrorMessage: error,
                checkName: (name) => checkName(id, name),
                onCancel() {
                    $scope.audienceNameProps = { isOpen: false };
                    $scope.$apply();
                    resolve({ canceled: true });
                },
                onSubmit(name) {
                    $scope.audienceNameProps = { isOpen: false };
                    $scope.$apply();
                    resolve({ name });
                },
            };
            $scope.$apply();
        });
    }

    $scope.handleActivatingAudience = async () => {
        const { channel } = $scope;
        const { current: { audience_app: { [channel]: audienceApp} } } = context;
        const { audience_id, audience_name } = audienceApp;
        const {name, canceled: nameCanceled} = await getAudienceName(audience_id, audience_name);
        const isBidstream = channel === CHANNEL_IDS.ARTICLES;
        const minimalSize = 150;
        const filterBidstreamDomains = channel === CHANNEL_IDS.ARTICLES;
        if (nameCanceled) return { canceled: true };

        audienceApp.audience_name = name;
        const { canceled } = await saveAudience({
            modalTitle: 'Review before activating',
            keepPhrasesText: 'Activate Audience',
            removePhrasesText: 'Remove & Activate',
        });
        if (canceled) return { canceled: true };

        const { $root: { user: { id: userId } } } = $scope;
        const { audience_segment: currSegments } = audienceApp;
        const demographicsDataOk = await checkDemographicsData(currSegments, channel, userId, {isBidstream, minimalSize, filterBidstreamDomains});
        if (!demographicsDataOk) return { canceled: true };

        return {
            audienceId: audienceApp.audience_id,
            audienceName: audienceApp.audience_name,
        };
    };

    $scope.navToPrevTab = () => {
      $scope.selectedTab = $scope.prevTab || $scope.tabs[0];
      $scope.$digest();
    };

    $scope.navToAudienceBuilder = () => {
        $state.go(AUDIENCE_STATES.BUILDER);
    };

    $scope.refineAudienceClick = () => {
        MixpanelAudience.trackRefine($scope.selectedTab.label.toLowerCase(), $scope.channel);
        MixpanelAudience.trackAudienceExplorerTopicClick('All Interests', 'audience-explorer', $scope.channel);
        $scope.navToAudienceBuilder();
    };

    $scope.onSelectTab = function (selectedTab) {
        $scope.prevTab = $scope.selectedTab;
        $scope.selectedTab = selectedTab;

        $scope.$digest();

        MixpanelAudience.trackPageView(selectedTab.label, $scope.channel);
    };

    $scope.audienceInfoTooltipContent = function() {
        const channel = (context.current.audience_app || {}).current_channel;
        const audienceSegment = (context.current.audience_app[channel.value] || {}).audience_segment || [];
        const divWrapper = (content) => `<div style="line-height: 19px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">${content}</div>`;
        let tooltipContent = channel.label === 'All' ? '' : divWrapper(`<strong>Channel:</strong> ${channel.label}`);
        audienceSegment.forEach((segment) => {
            const segmentTypeLabel = SEGMENT_ROW_MAP[segment['type']]['label'];
            tooltipContent += divWrapper(`<strong>${segmentTypeLabel}:</strong> ${getSegmentValuesSummary(segment, filtersPartition, true)}`);
        });

        return tooltipContent;
    };

    $scope.isTabAvailable = function(tabName) {
        return !!_.find($scope.tabs, {value: tabName});
    };

    $scope.exportControl.export = ()=> {
        $ngRedux.dispatch(updateShowShortSpinner(true));
        const tvProm = $scope.isTabAvailable($scope.TABS_NAMES.tv) && $scope.exportControl.getAudienceTvExportDependencies();
        const interestsProm = $scope.isTabAvailable($scope.TABS_NAMES.wiki) && $scope.exportControl.getAudienceInsightsExportDependencies();

        $q.all([tvProm, interestsProm])
          .then(([audienceTv, audienceInterests]) => {
              $ngRedux.dispatch(updateShowShortSpinner(false));
              let [topics, websites, phrases, searches, categories, purchaseAffinities, interestsDemographicsData] = audienceInterests || [];
              const [data, tvDemographicsData, filteredByNetworks] = audienceTv || [];
              const demographicsData = tvDemographicsData || interestsDemographicsData;

              topics = _.orderBy(topics, 'interest-portion', 'desc');
              const audienceSegment = (context.current.audience_app[channel] || {}).audience_segment || [];

              const isDebugUser = $rootScope.user.userType === USER_TYPES.DEBUG;
              const shouldShowNetwork = isSmartTvChannel(channel) || (isDebugUser && channel === CHANNEL_IDS.ARTICLES);

              const audienceInterestExportData = {topics, websites, phrases, searches, categories, purchaseAffinities};
              const tvShowsExportData = {data, withNetworks: shouldShowNetwork, filteredByNetworks};
              const mutualExportData = {segment: audienceSegment, demographicsData, channel: $scope.channel};
              let excel = audienceExplorerExportService.exportToExcel(tvShowsExportData, audienceInterestExportData, mutualExportData, showTvTab);
              segmentInterestExportService.excelDownloader(excel);
          })
          .catch(()=> {
              $ngRedux.dispatch(updateShowShortSpinner(false));
        });
    }
}

module.exports = audienceExplorerModule;
